import { useState, useEffect } from 'react';
const useSrLabel = () => {
  const [srLabelVisibility, setSrLabelVisibility] = useState(false);
  useEffect(() => {
    setTimeout(() => setSrLabelVisibility(true), 30);
  }, []);
  return srLabelVisibility;
};
export { useSrLabel as default };
